/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Components.Common {
    "use strict";

    interface IRgb {
        r: number;
        g: number;
        b: number;
    }

    export class AccessibleColorUtil {
        private static readonly AA_CONTRAST = 4.5;
        private static readonly BASE_CONTRAST = 3;
        private static readonly WHITE_LUM = 1;
        private static readonly BLACK_LUM = 0;

        static meetsAobContrast(buttonColor: string): boolean {
            const button = AccessibleColorUtil.hexToRgb(buttonColor);
            if (!button) {
                throw new Error('Unsupported button color format: ' + buttonColor);
            }

            const buttonLum = AccessibleColorUtil.relativeLuminance(button);
            const textLum = AccessibleColorUtil.accessibleTextLuminance(buttonLum);

            return AccessibleColorUtil.contrastRatio(buttonLum, textLum) >= AccessibleColorUtil.AA_CONTRAST
                && AccessibleColorUtil.contrastRatio(buttonLum, AccessibleColorUtil.WHITE_LUM) >= AccessibleColorUtil.BASE_CONTRAST;
        }

        private static accessibleTextLuminance(backgroundLum: number): number {
            const whiteRatio = AccessibleColorUtil.contrastRatio(AccessibleColorUtil.WHITE_LUM, backgroundLum);
            const blackRatio = AccessibleColorUtil.contrastRatio(AccessibleColorUtil.BLACK_LUM, backgroundLum);

            return whiteRatio > blackRatio ? AccessibleColorUtil.WHITE_LUM : AccessibleColorUtil.BLACK_LUM;
        }

        private static contrastRatio(l1: number, l2: number): number {
            return (Math.max(l1, l2) + 0.05) / (Math.min(l1, l2) + 0.05);
        }

        private static relativeLuminance(rgb: IRgb): number {
            const toLinear = AccessibleColorUtil.srgbChannelToLinear;

            return 0.2126 * toLinear(rgb.r) + 0.7152 * toLinear(rgb.g) + 0.0722 * toLinear(rgb.b);
        }

        private static srgbChannelToLinear(v255: number): number {
            const v = v255 / 255;

            return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
        }

        private static hexToRgb(color: string): IRgb {
            let hex = (color || '').trim().replace(/^#/, '');

            if (hex.length === 3) {
                hex = hex.split('').map(c => c + c).join('');
            }

            if (!/^[0-9a-f]{6}$/i.test(hex)) {
                return null;
            }

            const num = parseInt(hex, 16);

            return {
                r: (num >> 16) & 255,
                g: (num >> 8) & 255,
                b: num & 255
            };
        }
    }
}
